import { RoundsListQueryParams, useRoundsListQuery } from '../queries';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { FormState } from 'react-hook-form';
import { Input } from '~/components/Input';

interface Props<TFormState extends BaseFormState> {
  onChange?: (values: number[]) => void;
  query?: RoundsListQueryParams;
  formState?: FormState<TFormState>;
  disabled?: boolean;
  value?: number[];
}

function RoundMultiSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = { results: [] }, isLoading } = useRoundsListQuery(props.query);

  return (
    <Input.MultiSelect
      options={data.results.map(o => [o.name ?? '', o.id ?? 0])}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={props.disabled || isLoading}
      placeholder="Välj serieomgång"
      ref={ref}
      {...props}
    />
  );
}

export const RoundMultiSelect = forwardRef(RoundMultiSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof RoundMultiSelectElement>;
